import { LitElement, html, css } from "lit-element";
import "@stofloos/components/atoms/inputs/input-textarea";
import "@stofloos/components/atoms/inputs/input-default";
import { style } from "./style";
import {findDeepTypes} from "@stofloos/utils/sw-constants";
import groupBy from "lodash-es/groupBy";
import {localize} from "@stofloos/actions/localize";

// language=CSS
export const StofwareJSONEditorStyle = css`
	:host {
		display: inline-block;
		padding: 0 0 70px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		position: relative;
	}

	[contenteditable="true"]:focus {
		outline: none;
	}

	input-textarea {
		width: 100%;
	}

	button {
		background: none;
		border: none;
		cursor: pointer;
		height: 24px;
		padding: 3px 5px;
		margin: 0 5px;
		width: 28px;
		color: var(--app-primary);
		font-size: 14px;
	}

	button:hover {
		color: var(--app-accent);
	}
`;

export class StofwareJSONEditor extends LitElement {
	static get properties() {
		return {
			name: { type: String },
			label: { type: String },
			editor: { type: String },
			data: { type: Object },
			html: { type: Object },
			required: { type: Boolean },
			disabled: { type: Boolean }
		};
	}

	constructor() {
		super();
		this.editor = "default"
	}

	firstUpdated(_changedProperties) {
		super.firstUpdated(_changedProperties);
	}

	updated(_changedProperties) {
		super.updated(_changedProperties);
	}

	static get styles() {
		return [style, StofwareJSONEditorStyle];
	}

	render() {
		const json = JSON.stringify(this.data, undefined, 4);
		if(this.editor === "default") {
			return html`
				<input-textarea
					cast="json"
					label="${this.label}"
					name="${this.name}"
					id="editorjs"
					value="${json}"
				></input-textarea>
			`;
		}

		else if(this.editor === "simple") {
			const inputs = findDeepTypes(this.data, "string");
			const groups = groupBy(inputs, 'group');
			return html`
				${Object.entries(groups).map(([key, group]) => {
					return html`
						<h3>${localize("models::"+key)}</h3>
						${group.map( (obj) => {
							return html`
							<input-default type="text" name="${this.name}.${obj.key}" label="${obj.key}" value="${obj.value}"></input-default>
							`
						})}
					`
				})}
				
			`;
		} else {
			return html``;
		}

	}
}

customElements.define("json-editor", StofwareJSONEditor);
